export default __webpack_public_path__ + "static/media/PayatTable2.6df27033.jpg";